import { STATUSES } from '@/constants/common/message.constants'

import { type ShipmentOrdersListExEntity } from '../..'

/**
 * 配送依頼ステータス
 */
export type ShipmentOrderStatusType = ShipmentOrdersListExEntity['status']

export const SHIPMENT_ORDER_STATUS_TYPE = {
  /** 処理前 */
  PENDING: 'PENDING',
  /** 振り分け済 */
  ALLOCATED: 'ALLOCATED',
  /** 配車済 */
  DISPATCHED: 'DISPATCHED'
} as const satisfies Record<ShipmentOrderStatusType, ShipmentOrderStatusType>

export const SHIPMENT_ORDER_STATUS_TYPE_LABEL = {
  [SHIPMENT_ORDER_STATUS_TYPE.PENDING]: STATUSES.BEFORE_PROCESSING,
  [SHIPMENT_ORDER_STATUS_TYPE.ALLOCATED]: STATUSES.ALLOCATED,
  [SHIPMENT_ORDER_STATUS_TYPE.DISPATCHED]: STATUSES.DISPATCHED
} as const satisfies Record<ShipmentOrderStatusType, string>
